import { Box, Grid2 } from "@mui/material"
import { printEventDates } from "../../commonFunc"
import HouseOutlinedIcon from '@mui/icons-material/HouseOutlined';
import RoomIcon from '@mui/icons-material/Room';
import PhoneSharpIcon from '@mui/icons-material/PhoneSharp';
import { CalendarDownMenu } from "./CalendarDownMenu";
import { HubFeaturedBannerImage } from "../../../pages/new/layout/HubFeaturedBannerImage";
export const TabEventFirstElement = ({firstBlog}) => {
  return (
    <Grid2 container spacing={2}>
      <Grid2
        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
        className="relative text-start text-white rounded-2xl"
        display="flex"
        flexDirection="column"
        justifyContent="end"
        alignItems="flex-start"
      >
        <div className="relative w-full max-w-full overflow-hidden rounded-2xl">
          <HubFeaturedBannerImage
            mediaPath={firstBlog?.postMedia}
            title={firstBlog?.title}
            postType={firstBlog?.postType}
            alt="event-img"
          />
          <Box
            sx={{ background: 'linear-gradient(0deg, #22c0b1, #22c0b1, #ffffff00)' }}
            className="absolute bottom-0 w-full rounded-b-2xl p-4 sm:p-6"
          >
            <h4 className="cursor-pointer text-2xl font-medium leading-tight sm:text-3xl sm:leading-snug md:text-[42px] md:leading-[54.6px]">
              {firstBlog?.title}
            </h4>
            <span className="mt-1 block text-sm sm:text-base">{printEventDates(firstBlog)}</span>
          </Box>
        </div>
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
        <Box className="py-2 sm:py-3">
          <h3 className="py-2 text-lg font-semibold sm:text-[22px]">
            <HouseOutlinedIcon className="mx-2" />
            WebSite
          </h3>
          <p className="pl-2">
            <a className="break-all underline text-[#22c0b1] sm:break-words" href={firstBlog.eventUrl}>
              {firstBlog.eventUrl}
            </a>
          </p>

          {firstBlog?.addressData && (
            <>
              <h3 className="py-2 text-lg font-semibold sm:text-[22px]">
                <RoomIcon className="mx-2" />
                Address
              </h3>
              <h5 className="pl-2 py-2 font-semibold">
                {firstBlog?.addressData?.title}
              </h5>
              <p className="pl-2 underline">{firstBlog?.addressData?.address}</p>
              <p className="pl-2 underline">
                {firstBlog.addressData?.city} {firstBlog.addressData?.state}{' '}
                {firstBlog.addressData?.zip} {firstBlog.addressData?.country}
              </p>
              <h3 className="py-2 text-lg font-semibold sm:text-[22px]">
                <PhoneSharpIcon className="mx-2" />
                Phone
              </h3>
              <p className="pl-2 underline">{firstBlog.addressData?.phone}</p>
            </>
          )}
        </Box>
        <Box className="px-0 py-2 sm:px-2 sm:py-3">
          <CalendarDownMenu eventObj={firstBlog} />
        </Box>
      </Grid2>
    </Grid2>
  );
}